import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { NAVIGATION_EVENT } from '@/constants/events'

const useNavigationListener = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const navigationListener = (ev) => {
      navigate(ev.detail)
    }
    document.addEventListener(NAVIGATION_EVENT, navigationListener)
    return () =>
      document.removeEventListener(NAVIGATION_EVENT, navigationListener)
  }, [navigate])
}

const navigate = (navObject) => {
  const ev = new CustomEvent(NAVIGATION_EVENT, { detail: navObject })
  document.dispatchEvent(ev)
}

export { navigate, useNavigationListener }
